module.exports = __webpack_public_path__ + "roboto-thin-webfont.8437f45dd349bed3bf73.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-thin-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-thin-webfont.svg
// module chunks = styles